function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n            body {\n              font-size: 16px; // Set the font size back to the chakra default\n              font-weight: 500;\n            }\n\n            .chakra-portal dd,\n            .chakra-portal dt {\n              line-height: inherit;\n            }\n            svg:not(:root) {\n              overflow: inherit;\n            }\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Global, css } from '@emotion/react';
import { CampaignsHealthStatusRenderer } from './CampaignsHealthStatusRenderer';
import { PopupProvider } from '../components/PopupProvider';
import { TapThemeProvider } from '@tapresearch/ui/components';
import { store } from '../store';
import { setTapiConfig } from '../config';
setTapiConfig();
var LazyCampaignFieldingView = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: 'fieldingView' */ './CampaignFieldingViewDefault');
});
var wrapContainer = function(Component) {
    var stylesOverride = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    // eslint-disable-next-line react/display-name
    return function(props) {
        return /*#__PURE__*/ React.createElement(TapThemeProvider, null, stylesOverride && /*#__PURE__*/ React.createElement(Global, {
            styles: css(_templateObject())
        }), /*#__PURE__*/ React.createElement(Provider, {
            store: store
        }, /*#__PURE__*/ React.createElement(PopupProvider, null, /*#__PURE__*/ React.createElement(Suspense, {
            fallback: /*#__PURE__*/ React.createElement("div", null)
        }, /*#__PURE__*/ React.createElement(Component, props)))));
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var tapiContainers = {
    CampaignFieldingView: wrapContainer(LazyCampaignFieldingView),
    CampaignsHealthStatusRenderer: wrapContainer(CampaignsHealthStatusRenderer, false)
};
